import { render, staticRenderFns } from "./AddCategoryButton.vue?vue&type=template&id=3bd86940&"
import script from "./AddCategoryButton.vue?vue&type=script&lang=js&"
export * from "./AddCategoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports